import { NavigationItem } from '@beautyapp/layout';

export const adminNavigation: NavigationItem[] = [
  {
    id: 'applications',
    title: 'მენიუ',
    translate: 'NAV.APPLICATIONS',
    type: 'group',
    children: [
      {
        id: 'dashboards',
        title: 'ადმინისტრაცია',
        translate: 'NAV.administration',
        role: ['SUPERADMIN'],
        type: 'collapsable',
        icon: 'people',
        children: [
          {
            id: 'organizations',
            title: 'ორგანიზაციები',
            translate: 'NAV.organizations',
            type: 'item',
            url: '/organizations',
          },
        ],
      },
    ],
  },
];
export const navigation: NavigationItem[] = [
  {
    id: 'dashboard',
    title: 'მთავარი გვერდი',
    translate: 'NAV.DASHBOARDS',
    type: 'item',
    icon: 'dashboard',
    url: '/dashboard',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
  },
  {
    id: 'cashier',
    title: 'სალარო',
    translate: 'NAV.CASHIER',
    type: 'item',
    icon: 'dollar-circle',
    url: '/cashier',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
  },
  {
    id: 'hr',
    title: 'HR',
    translate: 'NAV.HR',
    type: 'collapsable',
    icon: 'team',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
    children: [
      {
        id: 'employees',
        title: 'თანამშრომლები',
        translate: 'NAV.users',
        type: 'group',
        url: '/hr/employees',
        show: true,
      },
      {
        // beaut-579. Gated on the KEY, not on role names.
        //
        // The parent HR group still carries `['Admin', 'Administrator',
        // 'Manager']`, which no salon can change -- the same shape beaut-591
        // replaced on reports. Swapping this one child to `field.employee_salary`
        // is behaviour-neutral today: measured on stage 2026-09-28, the key is
        // held by Admin (18 staff), Administrator (5) and Manager (4) and by no
        // other role that has members, which is exactly who the parent already
        // admits. What it adds is that a salon can now untick it per branch and
        // have the menu disappear, instead of the screen erroring against a
        // backend that refuses it.
        //
        // Only this child, deliberately: the group's other entries (employees,
        // schedule overview) are not salary and must not follow the salary key.
        id: 'salary',
        title: 'ხელფასები',
        translate: 'NAV.salary',
        type: 'group',
        url: '/hr/salary',
        role: ['field.employee_salary'],
        show: true,
      },
      {
        id: 'schedule-overview',
        title: 'გრაფიკის მიმოხილვა',
        translate: 'NAV.scheduleOverview',
        type: 'group',
        url: '/hr/schedule-overview',
        show: true,
      },
      {
        id: 'payroll',
        title: 'ხელფასების დარიცხვა',
        translate: 'PAYROLL.title',
        type: 'group',
        url: '/hr/payroll',
        role: ['payroll.view'],
        show: true,
      },
    ],
  },

  {
    id: 'services',
    title: 'პროცედურები',
    translate: 'NAV.services',
    type: 'item',
    icon: 'shopping',
    url: '/services',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
  },
  {
    id: 'service-packages',
    title: 'სერვის პაკეტები',
    translate: 'NAV.service_packages',
    type: 'item',
    icon: 'gift',
    url: '/service-packages',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
  },

  {
    id: 'productions',
    title: 'მარაგები ',
    translate: 'NAV.productions',
    type: 'collapsable',
    icon: 'shopping-cart',
    show: true,
    children: [
      {
        id: 'products',
        title: 'პროდუქცია',
        translate: 'NAV.products',
        type: 'group',
        url: '/warehouse/products',
        show: true,
      },
      {
        id: 'realizations',
        title: 'რეალიზაცია',
        translate: 'NAV.realizations',
        type: 'group',
        url: '/warehouse/realization',
        show: true,
      },
    ],
    role: ['Admin', 'Administrator', 'Manager'],
  },

  {
    id: 'customers',
    title: 'მომხმარებლები',
    translate: 'NAV.customers',
    type: 'item',
    icon: 'user',
    url: '/customers',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
  },
  // beaut-491's duplicate list lives in the ADMIN menu, not here — see
  // libs/layout/src/lib/admin-layout/navigation.ts. It is a data-hygiene tool
  // used occasionally by one person, which is what that menu is for; the main
  // menu is the daily work.
  {
    id: 'calendars',
    title: 'კალენდარი',
    translate: 'NAV.calendars',
    type: 'collapsable',
    icon: 'calendar',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
    children: [
      {
        id: 'calendars_daily',
        title: 'დღის ფორმა',
        translate: 'NAV.calendars_daily',
        type: 'group',
        url: '/calendars/day',
        show: true,
      },
      {
        id: 'room',
        title: 'დღის ფორმა(ოთახები)',
        translate: 'NAV.calendars_room',
        type: 'group',
        url: '/calendars/room-calendar',
        show: true,
      },
      {
        id: 'calendars_daily_new',
        title: 'დღის ფორმა(new)',
        translate: 'NAV.calendars_daily_new',
        type: 'group',
        url: '/calendars/day-new',
        show: false,
      },
      {
        id: 'calendars_canceled',
        title: 'ჩაწერები',
        translate: 'NAV.calendars_canceled',
        type: 'group',
        url: '/calendars/all',
        show: true,
      },
      {
        id: 'online_booking',
        title: 'ონლაინ ჯავშანი',
        translate: 'NAV.online_booking',
        type: 'group',
        url: '/calendars/online-booking',
        show: true,
      },
    ],
  },
  {
    id: 'calendars_employee',
    title: 'კალენდარი',
    translate: 'NAV.calendars',
    type: 'collapsable',
    icon: 'calendar',
    role: ['Employee'],
    show: true,
    children: [
      {
        id: 'calendars_daily_employee',
        title: 'დღის ფორმა',
        translate: 'NAV.calendars_daily',
        type: 'group',
        url: '/calendars/day/employee',
        show: true,
      },
      {
        id: 'calendars_daily_new_employee',
        title: 'დღის ფორმა(new)',
        translate: 'NAV.calendars_daily_new',
        type: 'group',
        url: '/calendars/day-new',
        show: false,
      },
      {
        id: 'calendars_canceled_employee',
        title: 'ჩაწერები',
        translate: 'NAV.calendars_canceled',
        type: 'group',
        url: '/calendars/all',
        show: true,
      },
    ],
  },
  {
    id: 'ehealth',
    title: 'EHR',
    translate: 'NAV.ehr',
    type: 'collapsable',
    icon: 'medicine-box',
    role: ['Admin', 'Administrator', 'Manager', 'Employee'],
    show: true,
    children: [
      {
        id: 'patients',
        title: 'პაციენტები',
        translate: 'NAV.patients',
        type: 'group',
        url: '/ehealth/patients',
        show: true,
      },
      {
        id: 'ehr',
        title: 'EHR',
        translate: 'NAV.ehr',
        type: 'group',
        url: '/ehealth/ehr',
        show: true,
      },
      {
        id: 'erx',
        title: 'ERX',
        translate: 'NAV.erx',
        type: 'group',
        url: '/ehealth/erx',
        show: true,
      },
      {
        id: 'classification_codes',
        title: 'კლასიფიკაციის კოდები',
        translate: 'NAV.classification_codes',
        type: 'group',
        url: '/ehealth/classification-codes',
        // beaut-397: this entry carried NO role at all, so it rendered for
        // every role while the guard bounced anyone it did not allow — shown,
        // then redirected to /dashboard, exactly as reported.
        //
        // Mirrors CLINICAL_ROLES in ehealth.routes.ts. The two must stay the
        // same list: a role in the menu but not the guard gets the redirect,
        // and a role in the guard but not the menu can never reach the page.
        role: ['Admin', 'Administrator', 'Manager', 'Employee'],
        show: true,
      },
      {
        id: 'ehr-template',
        title: 'EHR Templates',
        translate: 'NAV.ehrTemplate',
        type: 'group',
        url: '/admin/templates',
        // Mirrors the route guard in admin.routes.ts.
        role: ['Admin', 'Administrator', 'Manager'],
        show: true,
      },
    ],
  },
  {
    id: 'stats',
    title: 'სტატისტიკა',
    translate: 'NAV.stats',
    type: 'collapsable',
    icon: 'dot-chart',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
    children: [
      {
        id: 'stats_detailed',
        title: 'დეტალური ძებნა',
        translate: 'NAV.stats_detailed',
        type: 'group',
        url: '/operations/list',
        role: ['Admin', 'Administrator', 'Manager'],
        show: true,
      },
      {
        id: 'operations',
        title: 'ოპერაციები',
        translate: 'NAV.operations',
        type: 'group',
        url: '/operations',
        role: ['Admin', 'Administrator', 'Manager'],
        show: true,
      },
      {
        id: 'invoices',
        title: 'ტრანზაქციები',
        translate: 'NAV.invoices',
        type: 'group',
        url: '/reports/invoices',
        role: ['Admin', 'Administrator', 'Manager'],
        show: true,
      },
      {
        id: 'transactions',
        title: 'ინვოისები',
        translate: 'NAV.transactions',
        type: 'group',
        url: '/transactions/all',
        role: ['Admin', 'Administrator', 'Manager'],
        show: true,
      },
      {
        id: 'consignations',
        title: 'კონსიგნაციები',
        translate: 'NAV.consignations',
        type: 'group',
        url: '/consignations',
        role: ['Admin', 'Administrator', 'Manager'],
        show: true,
      },
      {
        id: 'graphs',
        title: 'გრაფიკული დიაგრამები',
        translate: 'NAV.graphs',
        type: 'group',
        url: '/reports/graphs',
        role: ['Admin', 'Manager'],
        show: true,
      },
      {
        id: 'offers',
        title: 'შეთავაზებები',
        translate: 'NAV.offers',
        type: 'group',
        url: '/reports/offers',
        role: ['Admin', 'Administrator', 'Manager'],
        show: true,
      },
    ],
  },
  // beaut-591. `role` is fed straight to `*ngxPermissionsOnly` in
  // main.component.html, so every string here is a PERMISSION name --
  // 'Admin'/'Manager' only ever worked because role names are loaded into the
  // permission store beside real keys. Naming `field.reports` therefore needs
  // no new plumbing, and it is the only form a salon can change: a role name
  // is fixed in this file, a permission is a tick in branch settings.
  //
  // `field.reports` and not `field.revenue`, though revenue already exists.
  // Measured on stage 2026-09-27, `field.revenue` is held by Admin (18 users),
  // Administrator (5) and Manager (4) -- this menu is shown to Admin and
  // Manager. Reusing it would hand the reports section to 5 Administrators who
  // do not see it today. It also cannot express "reports but not the dashboard
  // turnover panel", which is a thing salons ask for separately.
  {
    id: 'reports',
    title: 'რეპორტები',
    translate: 'NAV.reports',
    type: 'collapsable',
    icon: 'bar-chart',
    role: ['field.reports'],
    show: true,
    children: [
      {
        id: 'profit_loss_report',
        title: 'მოგება-ზარალი',
        translate: 'NAV.profit_loss',
        type: 'group',
        url: '/reports/profit-loss',
        role: ['field.reports'],
        show: true,
      },
      {
        id: 'cash_flow',
        title: 'ფულადი ნაკადები',
        translate: 'NAV.cash_flow',
        type: 'group',
        url: '/reports/cash-flow',
        role: ['field.reports'],
        show: true,
      },
      {
        id: 'employee_income',
        title: 'თანამშრომლების შემოსავალი',
        translate: 'NAV.employee_income',
        type: 'group',
        url: '/reports/employee-income',
        role: ['field.reports'],
        show: true,
      },
      {
        id: 'service_analytics',
        title: 'სერვისების ანალიტიკა',
        translate: 'NAV.service_analytics',
        type: 'group',
        url: '/reports/service-analytics',
        role: ['field.reports'],
        show: true,
      },
      {
        id: 'category_analytics',
        title: 'კატეგორიების ანალიტიკა',
        translate: 'NAV.category_analytics',
        type: 'group',
        url: '/reports/category-analytics',
        role: ['field.reports'],
        show: true,
      },
      {
        id: 'client_spending',
        title: 'კლიენტების დახარჯვა',
        translate: 'NAV.client_spending',
        type: 'group',
        url: '/reports/client-spending',
        role: ['field.reports'],
        show: true,
      },
    ],
  },
  {
    id: 'expence',
    title: 'გასავალი',
    translate: 'NAV.EXPENCE',
    type: 'collapsable',
    icon: 'fall',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
    children: [
      {
        id: 'add_expences',
        title: 'გასავლის გატარება',
        translate: 'NAV.add_expences',
        type: 'group',
        url: '/expense',
        exactMatch: true,
        show: true,
      },
      {
        id: 'expense-categories',
        title: 'გასავლის კატეგორიები',
        translate: 'NAV.expense_categories',
        type: 'group',
        url: '/expense/categories',
        exactMatch: true,
        show: true,
      },
      // {
      //   id: 'expences',
      //   title: 'ისტორია',
      //   type: 'item',
      //   url: '/expences',
      //   exactMatch: true
      // }
    ],
  },
  {
    id: 'communication',
    title: 'კომუნიკაცია',
    translate: 'NAV.communication',
    type: 'collapsable',
    icon: 'message',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
    children: [
      // {
      //   id: 'communication_sms',
      //   title: 'Sms-ის გაგზავნა',
      //   translate: 'NAV.communication_sms',
      //   type: 'item',
      //   url: '/communication/sms',
      //   exactMatch: true
      // },
      {
        id: 'reminder',
        title: 'ვიზიტის შეხსენება',
        translate: 'NAV.visitReminder',
        type: 'group',
        url: '/marketing/reminder',
        exactMatch: true,
        show: true,
      },
      {
        id: 'communication_history',
        title: 'გზავნილების ისტორია',
        translate: 'NAV.communication_history',
        type: 'group',
        url: '/marketing/sms-history',
        exactMatch: true,
        show: true,
      },
      {
        id: 'communication_templates',
        title: 'SMS კონფიგურაცია',
        translate: 'NAV.communication_config',
        type: 'group',
        url: '/marketing',
        exactMatch: true,
        show: true,
      },
      {
        id: 'birthday_greetings',
        title: 'დაბადების დღეები',
        translate: 'NAV.birthdayGreetings',
        type: 'group',
        url: '/marketing/birthdays',
        exactMatch: true,
        show: true,
      },
      {
        id: 'birthday_config',
        title: 'დაბადების დღის კონფიგურაცია',
        translate: 'NAV.birthdayConfig',
        type: 'group',
        url: '/marketing/birthdays/config',
        exactMatch: true,
        show: true,
      },
    ],
  },
  {
    id: 'bookinghub',
    title: 'BookingHub',
    translate: 'NAV.bookinghub',
    type: 'item',
    icon: 'user',
    url: '/bookinghub',
    role: ['Admin', 'Administrator', 'Manager'],
    show: true,
  },
  // {
  //   id: 'bookinghub',
  //   title: 'Booking Hub',
  //   translate: 'NAV.bookinghub',
  //   type: 'collapsable',
  //   icon: 'interaction',
  //   role: ['Admin'],
  //   children: [
  //     {
  //       id: 'bookinghub_organizations',
  //       title: 'ორგანიზაციები',
  //       translate: 'NAV.organizations',
  //       type: 'item',
  //       url: '/bookinghub/organization',
  //       exactMatch: true,
  //     },
  //     {
  //       id: 'bookinghub_branches',
  //       title: 'ფილიალები',
  //       translate: 'NAV.branches',
  //       type: 'item',
  //       url: '/bookinghub/branch',
  //       exactMatch: true,
  //     }
  //   ],
  // },
];
